export function renderTextInputFieldFormFieldTemplate({
  indent,
  pathNameProp,
  formItemProps,
  labelWithDescription,
  toLowerCase
}: {
  indent: string
  pathNameProp: string
  formItemProps: string
  labelWithDescription: string
  toLowerCase: string
}): string {
  return `${indent}<FormField
${indent}  control={form.control}
${indent}  name=${pathNameProp}
${indent}  render={({ field: formField }) => (
${indent}    <FormItem${formItemProps}>
${indent}      ${labelWithDescription}
${indent}      <FormControl>
${indent}        <Input placeholder="Enter ${toLowerCase}" disabled={isPending} {...formField} />
${indent}      </FormControl>
${indent}      <FormMessage />
${indent}    </FormItem>
${indent}  )}
${indent}/>`
}
